module.exports = __webpack_public_path__ + "img/Monte_Kope_46.f334122a.jpg";